export default __webpack_public_path__ + "static/media/PostgreDB.a22b5e57.svg";